import { Router } from '@angular/router';
import { AlertService } from '../../../widgets/entry-components/alert/services/alert.service';
import { Component, Input, ViewChild, AfterViewInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { merge } from 'rxjs';
import { IDevice } from '@ahryman40k/ts-fhir-types/lib/R4';

@Component({
  selector: 'inc-device-table',
  templateUrl: './device-table.component.html',
  styleUrls: ['./device-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('150ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DeviceTableComponent implements AfterViewInit, OnChanges {
  expandedElement;
  displayedColumns: string[] = ['identifier', 'manufacturer', 'model', 'status', 'type', 'star'];
  dataSource: MatTableDataSource<IDevice> = new MatTableDataSource<IDevice>();
  dataLength: any = 6;

  @Input() typeDisabled: boolean;
  @Input() statusDisabled: boolean;
  @Input() deviceList: IDevice[];
  @Input() filtered: boolean;
  @Input() actPage: number;
  @Input() pageSize: number;
  @Input() hideDeleteButton = false;
  @Output() callSortSizeChanged = new EventEmitter<{ pageSize: number, sort: { active: string, direction: string }, pageIndex: number }>();
  @Output() callDelete = new EventEmitter<string>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private alertService: AlertService, private router: Router) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.deviceList) {
      this.paginator.pageIndex = this.actPage;
      if (this.paginator.pageIndex === 0) {
        this.paginator.length = this.pageSize;
      }
      if (changes.deviceList.currentValue.length > this.pageSize) {
        this.dataSource.data = changes.deviceList.currentValue.slice(0, changes.deviceList.currentValue.length - 1);
        this.paginator.length += this.pageSize;
      } else {
        this.dataSource.data = changes.deviceList.currentValue;
      }
    }
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    merge(this.sort.sortChange, this.paginator.page).subscribe((data: any) => {
      if (data && data.pageSize) {
        this.callSortSizeChanged.emit({
          pageSize: data.pageSize,
          sort: { active: this.sort.active, direction: this.sort.direction },
          pageIndex: data.pageIndex
        });
      }
      if (data && data.active) {
        this.callSortSizeChanged.emit({
          pageSize: this.paginator.pageSize,
          sort: { active: data.active, direction: data.direction },
          pageIndex: data.pageIndex
        });
      }
    });
  }

  stopProp(event: Event) {
    event.stopPropagation();
  }

  navDevice(url: string, device: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    localStorage.removeItem('device');
    this.router.navigateByUrl(url, { state: { parameter: device } });
  }

  deleteDeviceAlert(id: string, identifier: string) {
    this.alertService.presentDelete(identifier, 'DEVICE', () => { this.callDelete.emit(id); });
  }

}
